import { Outlet } from 'react-router-dom';
import big_circle from '../assets/images/design/big-circle-bounce.png';
import mini_dot from '../assets/images/design/mini-dot.png';
import mini_circle_orchid from '../assets/images/design/mini-orchid-circle.png';
import mini_retangle from '../assets/images/design/mini-retangle.png';
import Female from './Female';
import NavBar from './NavBar';

const PublicLayout = () => {
   return (
      <main className='background-main'>
         <NavBar />
         <div className='container pt-12'>
            <img
               src={big_circle}
               alt='big_circle'
               className='hidden md:block absolute opacity-50 animate-bounce-left-right-slow left-[40%] top-[5%] w-48'
            />
            <img src={big_circle} alt='big_circle' className='absolute opacity-50 animate-bounce-slow left-[3%] bottom-[10%] w-48' />
            <img src={mini_circle_orchid} alt='mini_circle_orchid' className='absolute animate-movesquare-slow left-[45%] top-[35%]' />
            <img src={mini_dot} alt='mini_dot' className='absolute animate-movesquare-reverse-slow left-[45%] top-[40%] ' />
            <img src={mini_retangle} alt='mini_retangle' className='absolute  animate-spin-slow left-[50%] top-[53%]' />
            <div className='container grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-40 z-40'>
               <Female />
               <Outlet />
            </div>
         </div>
      </main>
   );
};

export default PublicLayout;
